import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Tracking from "assets/images/Tracking.png";

function PasswordResetEmailSent() {
  const navigate = useNavigate();
  const { palette } = useTheme();
  const backgroundAlt = palette.background.alt;
  const primary = palette.primary.main;
  const isLargeScreen = useMediaQuery("(min-width: 1000px)");

  const logoImage =
    "https://imagedelivery.net/Fnktb-343nSB5il_1lVAsw/6d1d68c7-b3e0-4d6c-0660-d2f402baaa00/public";

  const handleBackToLogin = () => {
    navigate("/");
  };

  return (
    <Box
      sx={{
        backgroundImage: `url(${Tracking})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        width="100%"
        backgroundColor={backgroundAlt}
        p="1rem 6%"
        textAlign="center"
      >
        <Typography color={primary} variant="h1" gutterBottom>
          Welcome to ALT Coach!
        </Typography>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Empowering educators through professional development. We’re here to
          support you at every step of your learning journey.
        </Typography>
      </Box>
      <Box
        width={isLargeScreen ? "50%" : "93%"}
        p="2rem"
        m="2rem auto"
        borderRadius="1.5rem"
        backgroundColor={backgroundAlt}
        data-testid="box"
        textAlign="center"
      >
        <Typography variant="h2" color="primary">
          Check Your Email
        </Typography>
        <Box my={2}>
          <img
            width="300px"
            height="auto"
            src={logoImage.replace("/public", "/xlarge")}
            alt="verification email sent"
            className="verification-image"
          />
        </Box>
        <Typography variant="h5" color="primary">
          A password reset email has been sent. Follow the instructions in the
          email to reset your password and regain access to your ALT Coach
          account.
        </Typography>
        <Typography variant="body1" sx={{ mt: 2 }}>
          If you don’t see the email in your inbox, please check your spam or
          junk folder. If you need further assistance, contact our support team.
        </Typography>
        <Box display="flex" flexDirection="column" gap={2} marginTop="20px">
          <Button
            variant="contained"
            color="secondary"
            sx={{ width: 200, mx: "auto" }}
            onClick={handleBackToLogin}
          >
            Back to Login Page
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default PasswordResetEmailSent;
